import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import Et3Button from "../../../et3-button";
import ET3Div from "../../../et3-div";
import { withLiteObserverAndTheme } from "../../../et3-enhanced-render";

const CopyPopUpButton = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const messageExtraData = getCorePopUpStore().MessageExtraData.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="center"
      alignItems="center"
      withShadow={true}
      width={1000}
      height={105}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        isEnabled={true}
        onClick={() => {
          navigator.clipboard.writeText(messageExtraData);
          getCorePopUpStore().closePopUps();
        }}
        type="GET"
        size="LARGE"
        text="COPY"
      />
    </ET3Div>
  );
});

export default CopyPopUpButton;
